import { useQuery, UseQueryOptions } from "react-query";
import { ApiError, api } from "utils/api";
import { SearchResponse } from "../types";

const getReviewableList = (listId: string): Promise<SearchResponse> =>
  api(`/reviewables/lists/${listId}`);

/**
 * Custom hook to get reviewables for a list id
 *
 * NOTE: Changing the perPage impacts clearing of the cache for project list edits
 */
const useReviewableList = (
  listId: string,
  options: UseQueryOptions<SearchResponse, ApiError> = {}
) =>
  useQuery<SearchResponse, ApiError>(
    ["reviewables", "lists", listId],
    () => getReviewableList(listId),
    options
  );

export { useReviewableList };
